import vueUIInitiator from '@/js/modules/vue-ui-initiator';
import WidgetListView from '@/js/vue-components/WidgetListView';
import WidgetTopList from '@/js/vue-components/WidgetTopList';
import SectionBCard from '@/js/mortgage/components/SectionBCard';

vueUIInitiator('js--widget-view', WidgetListView, 'widget-list-view');
vueUIInitiator('js--widget-top-list', WidgetTopList, 'widget-top-list');
vueUIInitiator('js--section-b-card', SectionBCard, 'section-b-card');

/* eslint-disable no-use-before-define */

document.addEventListener('DOMContentLoaded', setBannerProps);
function parse(obj) {
    return JSON.parse(obj.innerText);
}

function numWord(val, word) {
    const value = Math.abs(val) % 100;
    const num = value % 10;
    if (value > 10 && value < 20) return word[2];
    if (num > 1 && num < 5) return word[1];
    if (num === 1) return word[0];
    return word[2];
}

function transformThousand(el) {
    const word = numWord(Intl.NumberFormat('ru', {}).format(el / 1.0e3), [' тысяча', ' тысячи', ' тысяч']);
    return `${Intl.NumberFormat('ru', {
        maximumFractionDigits: 0,
        roundingMode: 'floor'
    }).format(el / 1.0e3)}${word}`;
}

function setVolume(volume) {
    return Math.abs(Number(volume)) >= 1.0e9
        ? `${Intl.NumberFormat('ru', {
              maximumFractionDigits: 0,
              roundingMode: 'floor'
          }).format(volume / 1.0e9)} млрд ₽`
        : '';
}
function setBannerProps() {
    const props = parse(document.getElementById('bannerProps'));
    const insertAmount = document.querySelector('.js--amount');
    const insertVolume = document.querySelector('.js--volume');
    const amount = props.pieces_total;
    const volume = props.million_total;
    insertAmount.innerText = transformThousand(amount);
    insertVolume.innerText = setVolume(volume);
}
